import { FeatureFlag, FeatureFlagsState } from '@/utils/featureFlags';
import { loadInitialFeatureFlags } from '@/utils/experimentQueryParams';

let cachedFlags: FeatureFlagsState = loadInitialFeatureFlags();

export function setCachedFeatureFlags(next: FeatureFlagsState) {
  cachedFlags = next;
}

export function getCachedFeatureFlags(): FeatureFlagsState {
  return cachedFlags;
}

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return !!cachedFlags[flag];
}
